import { type ReactNode, useEffect, useRef } from 'react';

/** Modal confirmation for actions that change who can see or edit a month. */
export function ConfirmDialog({
  title,
  children,
  confirmLabel,
  busy = false,
  disabled = false,
  cancelLabel = 'Annulla',
  error,
  onConfirm,
  onCancel,
  wide = false,
}: {
  title: string;
  children: ReactNode;
  confirmLabel: string;
  busy?: boolean;
  /** The confirmation not possible yet (a field missing), without «Attendere…». */
  disabled?: boolean;
  /** The label of the button that closes the dialog. */
  cancelLabel?: string;
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
  /** A larger dialog, for a form with a table. */
  wide?: boolean;
}) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    dialogRef.current?.showModal();
  }, []);

  return (
    <dialog
      ref={dialogRef}
      className={wide ? 'dialog wide-dialog' : 'dialog narrow'}
      onClose={onCancel}
    >
      <div className="stack">
        <h2>{title}</h2>
        {children}
        {error && <p className="error">{error}</p>}
        <div className="actions">
          <button type="button" onClick={onCancel} disabled={busy}>
            {cancelLabel}
          </button>
          <button type="button" className="primary" onClick={onConfirm} disabled={busy || disabled}>
            {busy ? 'Attendere…' : confirmLabel}
          </button>
        </div>
      </div>
    </dialog>
  );
}
